import React, { useState, useEffect } from 'react';
import './details.css';
import lodash from 'lodash';
import { useAppState } from '../../../contexts/appState'
import { useHistory } from 'react-router';
import useTranslation from '../../../hooks/use-translation';
import useLoader from '../../../hooks/use-loader';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import ErrorComponent from "../../Error-Component";
import successIcon from "../../../images/success.svg";
import failureIcon from "../../../images/failure.svg";
import { parseQueryString } from '../../../utils/utils'
import moment from 'moment';
import { srRescheduleAppointment, srCreateAppointment } from '../../../sources/book-appointments';
import { raiseGAEventForVaccination, sendPageViewEvent } from '../../../utils/network'
import config from '../../../config.json'

const Details = ({ handleBack, tryAgainClick, showSteps }) => {
    const params = parseQueryString();
    const { t } = useTranslation();
    const [{ booking, centerDetails }, dispatch] = useAppState();
    const history = useHistory();
    const urlParams = new URLSearchParams(window.location.search);
    const { showLoading, hideLoading } = useLoader();
    const [checked, setChecked] = useState(true);
    const [success, setSuccess] = useState(false);
    const [failure, setFailure] = useState(false);
    const auth_token = lodash.get(params, "auth_token");;
    const source_id = lodash.get(params, "source_id");
    const source_user_id = lodash.get(params, "source_user_id");
    const source_relation = lodash.get(params, "source_relation");
    const source_user_relation_id = lodash.get(params, "source_user_relation_id");
    const name = atob(lodash.get(params, "t", ''))
    const age = lodash.get(params, "source_age_years", '')

    // useEffect(() => {
    //     if (window.location.pathname === '/book-appointment/corporate') {
    //         sendPageViewEvent({ VirtualPageTitle: 'book-appointment/corporate/user-details' })
    //     } else {
    //         sendPageViewEvent({ VirtualPageTitle: 'book-appointment/all-centers/user-details' })
    //     }
    // }, [])

    const onBooking = async () => {
        showLoading();
        if (urlParams.toString() !== null && urlParams.toString().toLowerCase().includes("reschedule=true")) {
            const dataObj = {
                reason_id: 4,
                reason_text: 'Other',
                order_id: booking?.order_id,
                slot_id: booking?.slot_id,
            }
            const response = await srRescheduleAppointment(dataObj)

            if (lodash.get(response, "status") !== "success") {
                hideLoading();
                showSteps(false);
                setSuccess(true);
                setFailure(true);
                // raiseGAEventForVaccination({
                //     new_Category: config.gaBookAppointment,
                //     new_Action: "Booking failure",
                //     new_Label: centerDetails?.name,
                //     failureReason: lodash.get(response, "response.data.message", t('BOOK_ERROR_TEXT'))
                // });
            } else {
                showSteps(false);
                hideLoading();
                setSuccess(true);
                dispatch({ type: 'RESET_CENTER_DETAILS' });
                dispatch({ type: 'RESET_BOOKING' });
                // raiseGAEventForVaccination({
                //     new_Category: config.gaBookAppointment,
                //     new_Action: "Booking Success",
                //     new_Label: centerDetails?.name,
                //     failureReason: 'NA'
                // });
                return response;
            }
        }
        else {
            const dataObj = {
                is_self: source_relation === "Self",
                slot_id: booking?.slot_id,
                whatsapp_notification_consent: checked
            }
            const response = await srCreateAppointment(dataObj)

            if (lodash.get(response, "status") !== "success") {
                hideLoading();
                setSuccess(true);
                setFailure(true);
                showSteps(false);
                // raiseGAEventForVaccination({
                //     new_Category: config.gaBookAppointment,
                //     new_Action: "Booking failure",
                //     new_Label: centerDetails?.name,
                //     failureReason: lodash.get(response, "response.data.message", t('BOOK_ERROR_TEXT'))
                // });
            } else {
                hideLoading();
                setSuccess(true);
                dispatch({ type: 'RESET_CENTER_DETAILS' });
                dispatch({ type: 'RESET_BOOKING' });
                showSteps(false);
                // raiseGAEventForVaccination({
                //     new_Category: config.gaBookAppointment,
                //     new_Action: "Booking Success",
                //     new_Label: centerDetails?.name,
                //     failureReason: 'NA'
                // });
                return response;
            }
        }
    };

    const goToMyAppointments = () => {
        // raiseGAEventForVaccination({
        //     new_Category: config.gaBookAppointment,
        //     new_Action: config.gaGoToMyApt,
        //     new_Label: config.gaClick
        // });
        // if (window.location.pathname === '/book-appointment/corporate') {
        //     sendPageViewEvent({ VirtualPageTitle: 'book-appointment/corporate/status-page' })
        // } else {
        //     sendPageViewEvent({ VirtualPageTitle: 'book-appointment/all-centers/status-page' })
        // }
        if (urlParams.toString() !== null && urlParams.toString().toLowerCase().includes("reschedule=true")) {
            urlParams.delete('reschedule');
        }
        history.push(`/my-appointment/scheduled?${urlParams.toString()}`);
    }
    const errorButtonClickCallback = () => {
        failure ? tryAgainClick() : goToMyAppointments();
    }
    const onChange = () => {
        // raiseGAEventForVaccination({
        //     new_Category: config.gaBookAppointment,
        //     new_Action: config.gaBookingDetailsChange,
        //     new_Label: config.gaClick
        // });
        handleBack(false);
    }

    return (
        <>
            {success ?
                <ErrorComponent
                    image={failure ? failureIcon : successIcon}
                    text={failure ? t('FAILED') : t('SUCCESS')}
                    subText={failure ? t('FAIL_SUB') : t('SUCCESS_SUB')}
                    buttonText={failure ? t('TRY_AGAIN') : t('MY_APPOINTMENTS')}
                    showButton={true}
                    textCss={failure ? 'failureHeader' : "successHeader"}
                    subTextCss="success-text"
                    buttonClickCallback={errorButtonClickCallback}
                /> :
                <div className='mainContainer'>
                    <h1 className='headerCss'>{t('BOOKING_DETAILS')}</h1>
                    <div className='infoContainer'>
                        <div className='subHeader'>
                            <img width='36px;' height='36px;' className='imageCss' src='/icons/details.svg' alt='Patient Details' />
                            <span className='ml15'>{t('PATIENT_DETAILS')}</span>
                        </div>
                        <div className='personalDetails'>
                            <div className='row' >
                                <div className='rowLeft' >{t('CREATE_PROFILE_NAME_PLACEHOLDER')} :</div>
                                <div className='rowRight' style={{ color: '#333333' }} >{name}</div>
                            </div>
                            <div className='row'>
                                <div className='rowLeft'>{t('CREATE_PROFILE_AGE_PLACEHOLDER')} :</div>
                                <div className='rowRight' style={{ color: '#333333' }} >{age}{' '}{t('YEARS')} </div>
                            </div>
                        </div>
                        <div className='subHeader'>
                            <img width='36px;' height='36px;' className='imageCss' src='/icons/Injection.svg' alt='Appointment Details' />
                            <span className='ml15'>{t('APPOINTMENT_DETAILS')}</span>
                            <button className='btnCss' onClick={onChange}>{t('CHANGE')}</button>
                        </div>
                        <div className='centerDetails'>
                            <div className='row' >
                                <div className='rowLeft' >{t('CENTER')} </div>
                                <div className='rowRight'>{centerDetails?.address} </div>
                            </div>
                            <div className='row'>
                                <div className='rowLeft'>{t('DATE_TIME')} </div>
                                <div className='rowRight'>{moment(booking.date, ["DD/MM/YYYY"]).format("DD/MM/YYYY")},  {moment(booking.time, ["h:mm A"]).format("hh:mm A")}</div>
                            </div>
                        </div>
                    </div>
                    <div className='tncCon'>
                        <Checkbox
                            color="primary"
                            name="check"
                            onChange={() => setChecked(!checked)}
                            value={checked}
                            checked={checked}
                            icon={<img className='greenTick' src='/icons/ic_checkbox_unselected.svg' alt='Not selected' />}
                            checkedIcon={<img className='greenTick' src='/icons/green_tick.svg' alt='selected' />}
                        />
                        <div className='tncText'>{t('ACCEPT')}
                        </div>
                    </div>
                    <div className='bookBtn'>
                        <Button
                            style={{
                                width: '100%', alignSelf: 'flex-end',
                                textTransform: 'none', background: '#3CB5EA', margin: '23px 0'
                            }}
                            onClick={() => onBooking()}
                            variant="contained"
                            color="primary"
                        >
                            {t('CONFIRM')}
                        </Button>
                    </div>
                </div >
            }

        </>
    )
}
export default Details;